import { Outlet, useNavigate } from 'react-router-dom';
import { useStarterContext } from '@/context/StarterContext';
import { BottomNav } from './BottomNav';
import { AppHeader } from './AppHeader';
import { OfflineBanner } from '@/components/ui/OfflineBanner';
import { PrivateModeWarning } from '@/components/ui/PrivateModeWarning';
import { SyncIndicator } from '@/components/ui/SyncIndicator';

export function AppShell() {
  const navigate = useNavigate();
  const { syncState } = useStarterContext();

  return (
    <>
      <OfflineBanner />
      <PrivateModeWarning />
      <main className="page-container">
        <AppHeader
          onSettingsClick={() => navigate('/settings')}
          right={<SyncIndicator syncState={syncState} />}
        />
        <Outlet />
      </main>
      <BottomNav />
    </>
  );
}
